import React from 'react';
import {labels} from '../../util/uiconstants';
import MotifBreadcrumb from '@ey/motif-react-wrapper/Breadcrumb';
import MotifBreadcrumbItem from '@ey/motif-react-wrapper/BreadcrumbItem';
import styled from 'styled-components';
import {useLocation} from 'react-router-dom';
import EllipsesControl from '../Common/EllipsesControl/EllipsesControl';
import {IconoirHome} from '@ey-xd/motif-icon';
import {useHistory} from 'react-router-dom/cjs/react-router-dom.min';

function BreadCrumbNavigation(props) {
	console.log('inside breadcrumb');
	console.log(props);
	const location = useLocation();
	const history = useHistory();
	console.log(location);

	const getLinkAndLabel = (routeItem) => {
		var linkLabel = {link: routeItem.link, label: routeItem.label};
		if (routeItem.isDynamicLabel && location?.state) {
			var lbl = location?.state?.customLabel;
			if (lbl && lbl.length > 0) {
				linkLabel.label = lbl;
				linkLabel.link = location.pathname + location?.search;
			}
		}
		return linkLabel;
	};
	return (
		<Mainwrapper>
			<section className="breadcrumbwrapper motif-body3-default-regular">
				<StyledBreadcrumb>
					{props.breadCrumbList &&
						props.breadCrumbList.map((item) => {
							var dynamicLinkInfo = null;
							if (item.isDynamicLabel && location?.state) {
								dynamicLinkInfo = getLinkAndLabel(item);
							}
							return (
								<MotifBreadcrumbItem
									key={item.link}
									icon={item.label == labels.homeLabel ? IconoirHome : null}
									onClick={()=> history.push(dynamicLinkInfo == null ? item.link : null)}
									className="breadcrumbItem"
								>

									{dynamicLinkInfo == null ? item.label : 
									
									<EllipsesControl
										content={dynamicLinkInfo.label}
										tooltip={dynamicLinkInfo.label}
										displayId={''}
										noOfLines={1}
										ellipsisClass="dynamiclinkinfo"
									/>
									}									
								</MotifBreadcrumbItem>
							);
						})}
				</StyledBreadcrumb>
			</section>
		</Mainwrapper>
	);
}

const StyledBreadcrumb = styled(MotifBreadcrumb)`
	cursor: default;
	.breadcrumbItem {
		font-size: var(--px-12) !important;
	}
	.breadcrumbItem:last-child {
		color: var(--neutrals-900);
	}
	.breadcrumbItem:hover:not(:last-child) {
		cursor: pointer;
	}
	.motif-breadcrumb-list {
		margin: 0;
	}
`;

const Mainwrapper = styled.section`
	width: 100%;
	.motif-breadcrumb {
		padding: var(--spacing-x-large) 0;
		width: 75%;
		display: flex;
		.motif-breadcrumb-list-item {
			.motif-breadcrumb-text {
				line-height: normal;
				align-items: center;
				.ellipses {
					display: inline-flex;
					width: var(--px-800);
				}
			}

			svg {
				min-width: var(--px-15) !important;
				min-height: var(--px-15) !important;
				fill: var(--neutrals-900);
				vertical-align: top;
			}

			.motif-icon {
				svg {
					vertical-align: top;
				}
			}
		}
	}
`;

export default BreadCrumbNavigation;
